import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { LucideAngularModule } from 'lucide-angular';
import { NgxPaginationModule } from 'ngx-pagination';
import { Icons } from '../../../shared/helpers/icons';
import { LogEntry } from '../../../shared/models/user.model';

@Component({
  selector: 'app-activity-log-modal',
  standalone: true,
  imports: [CommonModule, FormsModule, LucideAngularModule, NgxPaginationModule],
  templateUrl: './activity-log-modal.component.html'
})
export class ActivityLogModalComponent implements OnChanges {
  @Input() logs: LogEntry[] = [];
  @Input() loading = false;
  @Output() closed = new EventEmitter<void>();

  icons = Icons;
  searchQuery   = '';
  filteredLogs: LogEntry[] = [];

  readonly pageSize = 20;
  currentPage = 1;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['logs']) {
      this.applyFilter();
    }
  }

  filterList(): void {
    this.currentPage = 1;
    this.applyFilter();
  }

  private applyFilter(): void {
    const q = this.searchQuery.toLowerCase();
    this.filteredLogs = [...this.logs]
      .filter(e => !q ||
        (e.userName ?? '').toLowerCase().includes(q) ||
        (e.description ?? '').toLowerCase().includes(q)
      );
    this.currentPage = 1;
  }
}
